module.exports = __webpack_public_path__ + "assets/img/hbgd1.3757fb7e.png";